module.exports = __webpack_public_path__ + "static/media/end-virtual-class-guide.9a0d34d3.gif";